import { useFormik } from "formik";
import * as Yup from "yup";

const useQuestionsForm = (handleSubmit) => {
  return useFormik({
    initialValues: {
      email: "",
      name: "",
      message: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Էլ․ Հասցեի անվավեր ձևաչափ")
        .required("Պարտադիր դաշտ (Էլ․ Հասցե)"),
      name: Yup.string()
        .min(3, "Ամենաքիչը 3 նիշ")
        .required("Պարտադիր դաշտ (Անուն)"),
      message: Yup.string()
        .min(4, "Ամենաքիչը 4 նիշ")
        .required("Պարտադիր դաշտ (Հաղորդագրություն)"),
    }),
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });
};

export default useQuestionsForm;
